import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from "@angular/router";
import { AuthService } from "../auth.service";
import { of, switchMap } from "rxjs";
import { inject } from "@angular/core";

export const PermisoGuard: CanActivateFn | CanActivateChildFn | UrlTree = (route, state) => {
    const router: Router = inject(Router);
    const queryParams: Record<string, string> = {};
    const layout = route.queryParamMap.get('layout');
    const embed = route.queryParamMap.get('embed');

    if (layout) {
        queryParams.layout = layout;
    }

    if (embed) {
        queryParams.embed = embed;
    }

    return inject(AuthService)
        .verificarRutasPermitidas(route.routeConfig?.path || '')
        .pipe(
            switchMap((routeAllow) => {
                if (!routeAllow) {
                    const urlTree = router.createUrlTree(['/acceso-denegado'], {
                        queryParams: Object.keys(queryParams).length ? queryParams : undefined,
                    })
                    return of(urlTree);
                } else {
                    return of(true);
                }
            }),
        );
};
